const zIndex = {
  tutorialBox: 10000,
};

export default zIndex;
